import type { IconProps } from '@chakra-ui/react';
import { Icon } from '@chakra-ui/react';

export function Multiplier(props: IconProps) {
  return (
    <Icon viewBox="0 0 399 292" role="img" aria-label="6x" {...props}>
      <path
        d="M29.147 197.307c0-46.185 28.37-76.069 71.897-76.069s71.897 29.884 71.897 76.069c0 43.081-29.536 72.965-71.897 72.965-41.972 0-71.897-29.884-71.897-72.965zm76.561-175.813c33.033 0 57.517 15.524 62.569 48.514h25.65C188.875 29.644 160.116.148 109.594.148 28.37.148 0 68.455 0 156.944c0 84.996 31.48 134.674 101.044 134.674 59.461 0 97.547-42.692 97.547-95.475 0-55.888-38.863-96.251-94.826-96.251-37.309 0-66.456 18.629-79.281 45.021 0-81.115 31.868-123.419 81.224-123.419zM393.171 77.77h-27.205l-57.906 81.115-57.906-81.115h-28.759l72.286 101.296-76.561 107.507h27.982l62.181-88.101 63.347 88.101H399L321.662 178.29l71.509-100.52z"
        fill="currentColor"
      />
    </Icon>
  );
}
